import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
    initLongPageParamObj,
    initLocationBaseObj,
    initLongPageSaveStatusObj,
    initUnitEditObj,
    initTrafficEditObj,
    initRequestErrorList,
    locationBaseTypeList
} from "../data/type";
import {
    getTableName
} from "../data/table";
import { cardActionsClasses } from "@mui/material";

//Sliceの作成
export const longPageSlice = createSlice({
    name: "longPage",
    //初期State(Typeからインポート)
    initialState: {
        param: initLongPageParamObj,
        locationBase: initLocationBaseObj,
        initLocationBase: initLocationBaseObj,
        saveStatus: initLongPageSaveStatusObj,
        surveyType: "",
        usePlanAareaId: "",
        storePlanAreaId: "",
        unitEdit: initUnitEditObj,
        trafficUnitEdit: initTrafficEditObj,
        rrBranchLog: {},
        statusLog: [],
        requestErrorList: initRequestErrorList
    },

    //toolKitを利用した値変更処理
    reducers: {
        setLongPageParamObj: (state, action) => {
            state.param = action.payload;
        },
        setLocationBase: (state, action) => {
            state.locationBase = action.payload;
        },
        setInitLocationBase: (state, action) => {
            state.initLocationBase = action.payload;
        },
        setSaveStatus: (state, action) => {
            state.saveStatus = action.payload;
        },
        setLongPageSurveyType: (state, action) => {
            state.surveyType = action.payload;
        },
        setUsePlanAareaId: (state, action) => {
            state.usePlanAareaId = action.payload;
        },
        setStorePlanAreaId: (state, action) => {
            state.storePlanAreaId = action.payload;
        },
        setOtherDocumentExcelPath: (state, action) => {
            //その他資料ページ
            state.locationBase.other_document_excel_path = action.payload; //その他添付書類_excelパス
        },
        setOtherDocumentPdfPath: (state, action) => {
            //その他資料ページ
            state.locationBase.other_document_pdf_path = action.payload; //その他添付書類_pdfパス
        },
        setRRdocumentPdfPath: (state, action) => {
            //RR内部用ページ
            state.locationBase.rr_document_pdf_path = action.payload; //RR内部用_パス
        },
        setBaseMap: (state, action) => {
            state.locationBase.map_excel_path = action.payload.map_excel_path;
            state.locationBase.map_excel_user = action.payload.map_excel_user;
            state.locationBase.map_pdf_path = action.payload.map_pdf_path;
            state.locationBase.map_pdf_user = action.payload.map_pdf_user;
        },
        setUnitEdit: (state, action) => {
            //競合個別編集フラグ
            state.unitEdit = action.payload;
        },
        setTrafficUnitEdit: (state, action) => {
            //リサーチの場合 通行量個別編集フラグ
            state.trafficUnitEdit = action.payload;
        },
        setRrBranchLog: (state, action) => {
            // 表示色変更用BQログデータ
            state.rrBranchLog = action.payload;
        },
        setStatushLog: (state, action) => {
            // 表示色変更用BQログデータ
            state.statusLog = action.payload;
        },
        setRequestErrorList: (state, action) => {
            // ロングページ依頼ボタン実施の親調査書エラーリスト
            state.requestErrorList = action.payload;
        },
        setDeleteRequestErrorList: (state, action) => {
            // 親調査書エラーリストから削除
            state.requestErrorList = state.requestErrorList.filter(
                (row) => 
                    !(
                        row.page === getTableName(action.payload.page) &&
                        row.column === action.payload.column
                    )
            )
        },
        setDeleteRequestTrafficErrorList: (state, action) => {
            // 親調査書エラーリストから通行量を削除
            state.requestErrorList = state.requestErrorList.filter(
                (row) => {
                    if (row.sub_key.includes("traffic_type") && row.sub_key.includes("traffic_type_seq")) {
                        const subKey = JSON.parse(row.sub_key);
                        if (row.page === "location_traffic" &&
                            row.column === action.payload.column &&
                            subKey.traffic_type === action.payload.trafficData.traffic_type &&
                            subKey.traffic_type_seq === action.payload.trafficData.traffic_type_seq
                        ) {
                            return false; // 一致する要素は削除
                        } else {
                            return true; // 一致しない要素は保持
                        }
                    } else {
                        return true; // sub_keyに必要な文字列が含まれていない場合も保持
                    }
                }
            )
        },
        setDeleteRequestConflictErrorList: (state, action) => {
            // 親調査書エラーリストから競合を削除
            state.requestErrorList = state.requestErrorList.filter(
                (row) => {
                    if (row.sub_key.includes("conflict_type") && row.sub_key.includes("conflict_sequence")) {
                        const subKey = JSON.parse(row.sub_key);
                        if (row.page === "location_conflict" &&
                            row.column === action.payload.column &&
                            subKey.conflict_type === action.payload.conflictData.conflict_type &&
                            subKey.conflict_sequence === action.payload.conflictData.conflict_sequence
                        ) {
                            return false; // 一致する要素は削除
                        } else {
                            return true; // 一致しない要素は保持
                        }
                    } else {
                        return true; // sub_keyに必要な文字列が含まれていない場合も保持
                    }
                }
            )
        },
        setDeleteRequestImpactErrorList: (state, action) => {
            // 親調査書エラーリストから競合を削除
            state.requestErrorList = state.requestErrorList.filter(
                (row) => {
                    if (row.sub_key.includes("store_code") && row.sub_key.includes("tenpo_name")) {
                        const subKey = JSON.parse(row.sub_key);
                        if (row.page === "location_impact" &&
                            row.column === action.payload.column &&
                            subKey.store_code === action.payload.impactData.store_code &&
                            subKey.tenpo_name === action.payload.impactData.tenpo_name
                        ) {
                            return false; // 一致する要素は削除
                        } else {
                            return true; // 一致しない要素は保持
                        }
                    } else {
                        return true; // sub_keyに必要な文字列が含まれていない場合も保持
                    }
                }
            )
        },
        setUpdateIsExcluded: (state, action: PayloadAction<{ index: number, labelName: keyof locationBaseTypeList, isExcluded: boolean}>) => {
            // 追加調査、その他資料ページの対象外チェックボックス
            const { index, labelName, isExcluded } = action.payload;
            const otherDocumentArray = state.locationBase[labelName];
            if (otherDocumentArray && otherDocumentArray[index]) {
                otherDocumentArray[index].isExcluded = isExcluded;
            }
        },
        setTradeAreaRealityFlag: (state, action) => {
            // 商圏ページ 実査ありなしプルダウン
            state.locationBase.trade_area_reality_flag =  action.payload;
        },
        setRRcomment: (state, action: PayloadAction<{ rrComment: string, labelName: keyof locationBaseTypeList}>) => {
            // RRコメント更新
            const { rrComment, labelName } = action.payload;
            state.locationBase[labelName] = rrComment;
        }

    },
});

export const {
    setLongPageParamObj,
    setLocationBase,
    setInitLocationBase,
    setSaveStatus,
    setLongPageSurveyType,
    setUsePlanAareaId,
    setStorePlanAreaId,
    setOtherDocumentExcelPath,
    setOtherDocumentPdfPath,
    setRRdocumentPdfPath,
    setBaseMap,
    setUnitEdit,
    setTrafficUnitEdit,
    setRrBranchLog,
    setStatushLog,
    setRequestErrorList,
    setDeleteRequestErrorList,
    setDeleteRequestTrafficErrorList,
    setDeleteRequestConflictErrorList,
    setDeleteRequestImpactErrorList,
    setUpdateIsExcluded,
    setTradeAreaRealityFlag,
    setRRcomment
} = longPageSlice.actions;
export default longPageSlice.reducer;
